/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';

// Action Declarations
// Suggested Action Name Standard: ORG_MODULE_ACTION_ANY
export const getLaboratoryOrdersAction = createAction('REFORAL_LABORATORY_REFERRAL_LAB_ORDERS');
// Home's Ongoing orders table only: no reducer handles it, so it never touches the Lab Orders list.
export const getHomeOngoingLabOrdersAction = createAction('REFORAL_GET_HOME_ONGOING_LAB_ORDERS');
export const getLaboratoryLabOrderMessageThreadAction = createAction('REFORAL_LABORATORY_LAB_ORDER_MESSAGE_THREAD');
export const updateLaboratoryLabOrderStatusAction = createAction('REFORAL_LABORATORY_UPDATE_LAB_ORDER_STATUS');

export const getLabOrdersAction = createAction('REFORAL_REFERRAL_LAB_ORDERS');
export const getLabOrderMessagesAction = createAction('REFORAL_LAB_ORDER_MESSAGES');
export const markLabOrderConversationReadAction = createAction('REFORAL_MARK_LAB_ORDER_CONVERSATION_READ');
export const markLabOrderConversationInListReadAction = createAction('REFORAL_MARK_LAB_ORDER_CONVERSATION_IN_LIST_READ');
export const markLabOrderConversationInListUnreadAction = createAction('REFORAL_MARK_LAB_ORDER_CONVERSATION_IN_LIST_UNREAD');
export const getLabOrderMessageThreadAction = createAction('REFORAL_LAB_ORDER_MESSAGE_THREAD');
export const sendLabOrderMessageAction = createAction('REFORAL_SEND_LAB_ORDER_MESSAGE');
export const getLabOrderMessageAttachmentsAction = createAction('REFORAL_GET_LAB_ORDER_MESSAGE_ATTACHMENTS');
export const downloadLabOrderMessageAttachmentAction = createAction('REFORAL_DOWNLOAD_LAB_ORDER_MESSAGE_ATTACHMENT');
export const deleteLabOrderMessageAttachmentAction = createAction('REFORAL_DELETE_LAB_ORDER_MESSAGE_ATTACHMENT');
export const deleteLabOrderAttachmentAction = createAction('REFORAL_DELETE_LAB_ORDER_ATTACHMENT');

export const displayLabOrderMessageAction = createAction('REFORAL_DISPLAY_LAB_ORDER_MESSAGE_ACTION');
export const updateLabOrderMessageAction = createAction('REFORAL_UPDATE_LAB_ORDER_MESSAGE');
export const deleteLabOrderMessageAction = createAction('REFORAL_DELETE_LAB_ORDER_MESSAGE');
export const clearLabOrderDataAction = createAction('REFORAL_CLEAR_LAB_ORDER_DATA');
export const deleteLabOrderReceiverMessageAction = createAction('REFORAL_DELETE_LAB_ORDER_RECEIVER_MESSAGE');
export const updateUnreadLabOrderMessageCountAction = createAction('REFORAL_UPDATE_LAB_ORDER_UNREAD_MESSAGE_COUNT');
export const updateLabOrderListAction = createAction('REFORAL_UPDATE_LAB_ORDER_LIST');
export const updateLabOrderMessageStatusAction = createAction('REFORAL_UPDATE_LAB_ORDER_MESSAGE_STATUS');

export const updateLabOrderFollowUpStatusAction = createAction('REFORAL_UPDATE_LAB_ORDER_FOLLOW_UP_STATUS');

export const updateLaboratoryFollowUpStatusAction = createAction('REFORAL_UPDATE_LABORATORY_ORDER_FOLLOW_UP');
